import { render } from "./Deprartment_Ligjor.vue?vue&type=template&id=70700dc9&scoped=true"
import script from "./Deprartment_Ligjor.vue?vue&type=script&lang=js"
export * from "./Deprartment_Ligjor.vue?vue&type=script&lang=js"

import "./Deprartment_Ligjor.vue?vue&type=style&index=0&id=70700dc9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70700dc9"]])

export default __exports__